export const SOCKET_REPORTS = {
    ADMIN_DELETE_USER: 'admin_delete_user',
    ADMIN_DELETE_POST: 'admin_delete_post',
    ADMIN_DELETE_COMMENT: 'admin_delete_comment',
    ADMIN_VIEWED_REPORTS: 'admin_viewed_reports',
    NEW_POST_REPORT: 'new_post_report',
    NEW_USER_REPORT: 'new_user_report',
    NEW_COMMENT_REPORT: 'new_comment_report',
}